package linkerpangoquipdb

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class Maintenance(
  public val id: Long,
  public val server_id: Long?,
  public val vehicle_vin: String,
  public val kilometers: Long,
  public val mechanic: String,
  public val workshop: String,
  public val description: String,
  public val date: Long,
  public val cost: Double,
  public val signature: String?,
)
